<template>
	<span>
		<span v-if="showNav">
			<a
				:aria-expanded="cmdaCollapse"
				class="sidebar-menu-item nav-link"
				data-toggle="collapse"
				@click="cmdaCollapse = !cmdaCollapse"
			>
				<template>
					<i class="fa pr-2 fa-signal text-blue"></i>
					<span class="nav-link-text">CMDA <b class="caret"></b></span>
				</template>
			</a>
			<collapse-transition :duration="{enter: 500, leave: 500}">
				<div
					v-show="cmdaCollapse"
					id="collapse-just1"
					:class="cmdaCollapse ? 'show' : ''"
					class="collapse collapse-just"
				>
					<ul class="nav nav-sm flex-column">
						<slot v-for="(item, index) in links" name="title">
							<router-link
								:key="index"
								:target="item.link"
								class="nav-link"
								:href="item.link"
								:to="item.link"
								@click.native="linkClick"
								:title="item.description"
								b-v-tooltip.hover
							>
								<template>
									<i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
									<span class="nav-link-text">{{ item.name }}</span>
								</template>
							</router-link>
						</slot>
					</ul>
				</div>
			</collapse-transition>
		</span>
	</span>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";

export default {
	name: "side-cmda-dynamic-group",
	components: {
		CollapseTransition,
	},
	data() {
		return {
			cmdaCollapse: false,
		};
	},
	computed: {
		links() {
		return this.$store.getters["getLinksByGroup"]('CMDA')
		},
		showNav() {
		return this.$store.getters["getLinksByGroup"]('CMDA').length > 0
		},
	},
	methods: {

		linkClick() {
			if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
				this.$sidebar.displaySidebar(false);
			}
		},
	},
};
</script>
